/* pantallas-alumno (B): LA TARJETA DE AJUSTES (piezas nuevas de la parte 2; tambien sirve a Gana
   creditos y a cualquier tarjeta de seccion con titulo).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   La tarjeta del Panel (fondo #141414, borde #222222, radio 18) con relleno 20 (16 en el celular) y
   16 de separacion entre lo de adentro; titulo de 17 seminegrita con icono naranja de 20. Las lineas
   divisorias van en #222222 (`LineaDivisoria`). `accion` va a la derecha del titulo. */
import React from 'react';

export default function TarjetaDeAjustes({ icono: Icono, titulo, accion, children, testid, className = '' }) {
  return (
    <section data-testid={testid} className={`rounded-[18px] border border-[#222222] bg-[#141414] p-4 md:p-5 flex flex-col gap-4 ${className}`.trim()}>
      {titulo ? (
        <div className="flex items-center justify-between gap-3 min-w-0">
          <h2 className="flex items-center gap-2.5 min-w-0 text-[17px] leading-snug font-semibold text-[#F4F4F3]">
            {Icono ? <Icono className="w-5 h-5 shrink-0 text-[#F27A2E]" aria-hidden="true" /> : null}
            <span className="min-w-0 break-words">{titulo}</span>
          </h2>
          {accion ? <div className="shrink-0">{accion}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}

export function LineaDivisoria({ testid, className = '' }) {
  return <div role="separator" data-testid={testid} className={`h-px w-full bg-[#222222] ${className}`.trim()} />;
}
